import { CSSProperties } from "react";
import { makeStyles } from "tss-react/mui";

import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from "@mui/material";

const useStyles = makeStyles()(() => ({
    childrenBox: {
        display: "inline-block",
    },
}));

export type TooltipProps = Omit<MuiTooltipProps, "arrow" | "title"> & {
    hide?: boolean;
    title?: MuiTooltipProps["title"];
    childrenBoxStyles?: CSSProperties;
    disableChildrenWrapper?: boolean;
};

export const Tooltip = ({
    children,
    hide = false,
    title = "",
    childrenBoxStyles = {},
    disableChildrenWrapper = false,
    ...rest
}: TooltipProps) => {
    const { classes } = useStyles();

    if (hide) {
        return children;
    }

    return (
        <MuiTooltip
            arrow
            placement="top"
            title={title}
            enterTouchDelay={50}
            slotProps={{
                popper: {
                    popperOptions: {
                        strategy: "fixed",
                    },
                    modifiers: [
                        {
                            name: "preventOverflow",
                            enabled: true,
                            options: {
                                altAxis: true,
                                padding: 8,
                                boundary: "viewport",
                            },
                        },
                        {
                            name: "flip",
                            enabled: true,
                            options: {
                                padding: 8,
                            },
                        },
                    ],
                },
            }}
            {...rest}
        >
            {disableChildrenWrapper ? (
                children
            ) : (
                <div className={classes.childrenBox} style={childrenBoxStyles}>
                    {children}
                </div>
            )}
        </MuiTooltip>
    );
};
